<script lang="ts">
  import { uiApi } from "$lib/ui-api";
  import { openModal, MessageModal } from "@thehood/svlib";
  export let title: string;

  async function supportSubmit(ev: Event) {
    ev.preventDefault();

    const formEl = ev.target as HTMLFormElement;
    const payload = Object.fromEntries(new FormData(formEl));
    const currentPath = window.location.href;
    const resp = await uiApi.postRaw(`${currentPath}/getRequest`, { ...payload, event: title });
    let mTitle = "Thank's for you message.";
    let message = `Our dedicated team will do their best to reach out to you as soon as possible.`;
    if (!resp.ok) {
      mTitle = "Oops something went wrong!";
      message = "Was impossible to send the message for your're request, try again!";
    }
    openModal(MessageModal, { title: mTitle, message });
    formEl.reset();
  }
</script>

<div class="no-tickets">
  <div class="form-wrapper">
    <h2 class="sf-800">REGISTER YOUR INTEREST FOR THIS MATCH</h2>
    <p class="pf-400">
      Register your interest today, fill out the form with your details, and our dedicated team will promptly assess
      your interests, ensuring a personalized experience tailored to your preferences.
    </p>
    <form id="notify" method="POST" action="?/contact-service">
      <form on:submit={supportSubmit}>
        <!-- <form id="notify" method="POST" action="?/contact-service" use:enhance={submitHandler}> -->
        <label for="name" class="d-flex flex-column pf-400">
          Enter your name
          <input type="text" name="name" placeholder="Name" required />
        </label>
        <label for="email" class="d-flex flex-column pf-400">
          Email address
          <input type="email" name="email" placeholder="Email" required />
        </label>
        <label for="phone" class="d-flex flex-column pf-400">
          Phone number
          <input type="text" name="phone" placeholder="Number" />
        </label>
        <label for="message" class="d-flex flex-column pf-400">
          Message
          <textarea name="message" placeholder="Optional message" />
        </label>
        <button>REGISTER</button>
      </form>
    </form>
  </div>
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .no-tickets {
    padding: 0.63em 0 0 0;
    margin: 0;

    @include desktop {
      padding: 2em;
    }
    .form-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 1.5625em;
      border-radius: 0.5em;
      text-align: center;

      @include desktop {
        border: 0.125em solid #000;
      }

      h2 {
        font-size: 1.5em;
        margin: 1.25em 0;
      }

      p {
        margin: 1.25em 0;
      }

      form {
        margin: auto;
        max-width: 97.5em;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 0.9375em;

        label {
          width: 100%;
          text-align: left;

          input,
          textarea {
            margin-top: 0.875em;
            height: 3.75em;
            padding: 0.625em;
            border: 0.125em solid #000;
            border-radius: 0.5em;
            background: none;
          }
        }
      }

      button {
        width: 100%;
        height: 3.75em;
        border-radius: 0.4375em;
        border: 0.125em solid #000;
        margin-top: 0.9375em;

        @include desktop {
          opacity: 70%;
          transition: opacity 0.2s ease-in-out;

          &:hover {
            opacity: 100%;
          }
        }
      }
    }
  }
</style>
